import { api } from "./client";

export interface MyOrg {
  id: string;
  slug: string | null;
  name: string;
  status?: string;
}

export interface MyOrgsResponse {
  organizations: MyOrg[];
  active_org_id: string | null;
}

// The user's org memberships + active org, proxied from ait-auth /api/orgs/mine.
export function fetchMyOrgs() {
  return api.get<MyOrgsResponse>("/api/dashboard/orgs");
}

// Switch the active org at ait-auth via the kraken backend proxy, which rotates
// the kraken session so the new token carries the new `org` claim. Pass null to
// switch to the default (no-org) scope.
export function switchOrg(organizationId: string | null) {
  return api.post<{ status: string; organization: unknown }>(
    "/api/auth/switch-org",
    { organization_id: organizationId },
  );
}
